/**
 * Web Style Import
 *
 */

import './style/dnb-date-picker.scss'
